"use client";

import { Box, BoxProps } from "@chakra-ui/react";
import { useScrollReveal } from "../../_hooks/useScrollReveal";

type Props = BoxProps & {
  delay?: number;
  children: React.ReactNode;
};

export function ScrollReveal({ delay = 0, children, ...rest }: Props) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <Box
      ref={ref}
      opacity={isVisible ? 1 : 0}
      transform={isVisible ? "translateY(0)" : "translateY(24px)"}
      transition="opacity 0.7s ease, transform 0.7s ease"
      transitionDelay={`${delay}s`}
      {...rest}
    >
      {children}
    </Box>
  );
}
